import { useEffect, useRef } from "react";
import { config } from "../config";
import { openWidgetSse } from "../utils/widgetSse";

/**
 * Listens to the sender's operation SSE stream and refreshes deferred
 * origination data when any operation status changes (the claim link owns the
 * operation, but updates are published on the sender userId too).
 */
export function useSenderOperationRefresh(
  linkId: string | null | undefined,
  enabled: boolean,
  onRefresh: () => void
): void {
  const onRefreshRef = useRef(onRefresh);
  onRefreshRef.current = onRefresh;

  useEffect(() => {
    if (!linkId || !enabled) return;

    const url = `${config.API_BASE_URL}/widget/links/${linkId}/operations/sse`;
    const conn = openWidgetSse({
      url,
      onOpen: () => {
        onRefreshRef.current();
      },
      onMessage: (event) => {
        try {
          const raw = event.data;
          const data = typeof raw === "string" ? JSON.parse(raw) : raw;
          if (data?.type === "heartbeat") return;
          onRefreshRef.current();
        } catch {
          // ignore malformed events
        }
      },
    });

    return () => {
      conn.close();
    };
  }, [linkId, enabled]);
}
